module.exports = __webpack_public_path__ + "static/media/1_en.dd6fe141.png";